$.fn.selectDropdown = function() {
  var self = this;

  if (!$(self).is('.input-dropdown')) {
    return;
  }

  var onItemSelected = function() {};

  self.onItemSelected = function(listener) {
    onItemSelected = listener;
  };

  self.getInput = function() {
    return self.find('input');
  };

  self.getDropdown = function() {
    return self.find('.dropdown > a');
  };

  self.getItems = function() {
    return self.find('.dropdown > .dropdown-menu a');
  };

  self.bindItems = function() {
    self.getItems().off('click.input-dropdown');
    self.getItems().on('click.input-dropdown', function(e) {
      e.preventDefault();
    
      var menuItem = $(this);
      var dropdown = menuItem.parents('.dropdown');
      var input = self.getInput();
      var menuItems = self.getItems();
      var content = menuItem.html();
      var value = menuItem.data('value');
    
      // Unselect all menu items
      menuItems.removeClass('selected');
    
      // Select the current menu item
      menuItem.addClass('selected');
    
      // update input and dropdown value
      input.val(value);
      input.trigger('change');
      dropdown.find('>a').html(content);

      onItemSelected(menuItem);
    });
  }

  self.selectItem = function(item) {
    var selectedItem;

    var currentItems = self.getItems();
    if (currentItems.length > 0) {
      if (item) {
        for (var i = 0; i < currentItems.length; i++) {
          var currentItem = currentItems[i];
          if (currentItem === item) {
            selectedItem = currentItem;
            break;
          }
        }
      } else {
        selectedItem = currentItems[0];
      }
    }

    if (selectedItem) {
      $(selectedItem).trigger('click');
    }
  };

  var value = self.getInput().val();
  if (value) {
    // input is set. 
    // search dropdown for correct value and select it
    var content;
    self.getItems().each(function() {
      var menuItem = $(this);
      if (menuItem.data('value') == value) {
        content = menuItem.html();
      }
    });

    // no value found in dropdown
    // clear input
    if (content) {
      self.getDropdown().html(content);
      self.getInput().trigger('change');
    } else {
      self.getInput().val('');
    }
  }

  return self;
};